import React from 'react';
import { getGenreString, formatDate, useOffer } from '../../utils/helpers';

import MediaDetails from '../MediaDetails';
import CastList from '../CastList';
import Swimlane from '../Swimlane';

import { IMedia } from '../../utils/models';
import { TAccessServiceType } from '../../@types/Access';
import { KiteIcon, KiteLink } from '@kite/react-kite';
export interface SeriesDetailsProps {
  media: IMedia;
  similarAssets: IMedia[];
  analytics: any;
  accessServices?: TAccessServiceType[];
}

const SeriesDetails = ({
  media: {
    title,
    imageUrl,
    description,
    descriptors,
    genres,
    ratings,
    releaseDate,
    topCast,
    offer,
    accessServices,
  },
  similarAssets,
  analytics,
}: SeriesDetailsProps) => {
  const { startTime, endTime } = useOffer(offer);
  const rating =
    ratings && ratings.find((rating) => rating.agency === 'usTv')?.rating;
  const genreString = getGenreString(genres);

  const header = (
    <div className="header">
      {genreString && <span className="header__detail">{genreString}</span>}
      {rating && <span className="header__detail">{rating}</span>}
    </div>
  );

  const footer = (
    <div className="footer">
      {/* Original Airdate */}
      {releaseDate && (
        <span className="footer__detail">
          <span className="label">Original Airdate</span>
          {formatDate(releaseDate)}
        </span>
      )}
      {!!accessServices?.length && (
        <span className="footer__access-cta">
          Accessible features are available for select episodes of this series
          on{' '}
          <KiteLink
            className="screenshot-access-block__description-link"
            href="https://access-app.spectrum.net/explore"
            type="standalone"
          >
            Spectrum Access
            <KiteIcon
              className="access-cta__link-icon"
              icon="ki-chevron-right"
              size="14px"
            />
          </KiteLink>
        </span>
      )}
    </div>
  );
  return (
    <>
      <MediaDetails
        title={title}
        imageUri={`${imageUrl}?sourceType=colorHybrid&twccategory=Poster&width=257`}
        description={description}
        header={genres?.length || rating ? header : null}
        footer={releaseDate ? footer : null}
        moods={descriptors?.moods}
        dates={{ startTime, endTime }}
      />
      {topCast?.length ? (
        <section>
          <h2 className="section-title">Cast</h2>
          <CastList cast={topCast} />
        </section>
      ) : null}

      {/* Related To Swimlane */}
      {similarAssets?.length ? (
        <>
          <hr className="page__divider" aria-hidden={true} />
          <Swimlane
            title={`Related To ${title}`}
            items={similarAssets}
            analyticsConfig={{
              analytics,
              eventCase:
                'SpectrumOnDemand_selectContent_related_tvShows_assetSelection',
            }}
          />
        </>
      ) : null}
    </>
  );
};

export default SeriesDetails;
